export const MAX_MENU_FAVORITES = 4;

export function menuFavoritesKey(user, storeId) {
  const account = user?.id ?? user?.username;
  if (account === undefined || account === null || account === '') return null;
  return `tools:menu-favorites:v1:${encodeURIComponent(String(account))}:${encodeURIComponent(String(storeId ?? ''))}`;
}

export function parseMenuFavorites(raw) {
  try {
    const value = JSON.parse(raw);
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter((id) => typeof id === 'string' && id.length > 0 && id.length < 80))].slice(0, MAX_MENU_FAVORITES);
  } catch { return []; }
}

// 저장된 ID를 링크로 직접 사용하지 않고 현재 권한의 서비스 목록에서 찾는다.
export function resolveMenuFavorites(ids, services) {
  return ids.map((id) => services.find((service) => service.id === id && !service.devOnly)).filter(Boolean);
}

export function toggleMenuFavorite(ids, id) {
  if (ids.includes(id)) return ids.filter((item) => item !== id);
  return ids.length < MAX_MENU_FAVORITES ? [...ids, id] : ids;
}
